import { PaymentsType } from "interfaces";
import { get } from "services/services.methods";
import { PaymentsTypesPaths } from "services/services.paths";

export const getAllPaymentsTypes = async () => {
  const response = await get<PaymentsType[]>(
    PaymentsTypesPaths.getAllPaymentsTypes
  );

  return response.data;
};


export const getAllPayments = async () => {
  const response = await get<PaymentsType[]>(
    PaymentsTypesPaths.getAllPaymentsTypes
  );

  return response;
};
